/* eslint-disable import/order */
/* eslint-disable prettier/prettier */
import { routes } from "@bvi/admin-panel/api-routes";
import { apiContainer, getItemTags, getListTag, invalidateTags, provideTagsList, TagTypes, WithId } from "@bvi/admin-panel/shared/api";
import { getResponseData } from "@bvi/api-interfaces/response";
import { IManageBaseListResponse, IManageBaseResponse } from '@bvi/api-interfaces/response/manage-base-data';

type IOrganizationListResponse = IManageBaseListResponse;
type IOrganizationResponse = IManageBaseResponse;

export const organizationApi = apiContainer.injectEndpoints({
  endpoints: (builder) => ({
    getOrganizationList: builder.query<IOrganizationListResponse, void>({
      query: () => ({
        url: routes.organization.findAll(),
        method: 'GET',
      }),
      providesTags: (result) =>
        result
          ? [
            ...getItemTags(TagTypes.ORGANIZATION, getResponseData(result)),
            getListTag(TagTypes.ORGANIZATION),
          ]
          : [getListTag(TagTypes.ORGANIZATION)],
    }),

    getByIdOrganization: builder.query<IOrganizationResponse, number>({
      query: (id) => ({
        url: routes.organization.findOne(),
        method: 'GET',
        params: { id },
      }),
      providesTags: provideTagsList(TagTypes.ORGANIZATION)
    }),

    createOrganization: builder.mutation<
      IOrganizationResponse,
      { name: string }
    >({
      query: (data) => ({
        url: routes.organization.create(),
        method: 'POST',
        data,
      }),
      invalidatesTags: invalidateTags(getListTag(TagTypes.ORGANIZATION)),
    }),

    updateOrganization: builder.mutation<
      IOrganizationResponse,
      WithId<{ name: string }>
    >({
      query: ([id, data]) => ({
        url: routes.organization.update(),
        method: 'PUT',
        data: { id, name: data.name },
      }),
      invalidatesTags: invalidateTags(getListTag(TagTypes.ORGANIZATION)),
    }),

    deleteOrganization: builder.mutation<void, number>({
      query: (id) => ({
        url: routes.organization.remove(),
        method: 'DELETE',
        params: { id },
      }),
      invalidatesTags: invalidateTags(getListTag(TagTypes.ORGANIZATION)),
    }),
  }),
});

export const {
  useGetOrganizationListQuery,
  useLazyGetOrganizationListQuery,
  useGetByIdOrganizationQuery,
  useLazyGetByIdOrganizationQuery,
  useCreateOrganizationMutation,
  useUpdateOrganizationMutation,
  useDeleteOrganizationMutation
} = organizationApi;


